import React from 'react';
import './GallerySection.scss';
import { NavLink  } from "react-router-dom";

const GallerySection = (props) => (
    <div className="gallery-section">
        <div className="container">
            {
                props.photos.map((item, index) => (
                    <React.Fragment key={index}>
                        {item.link ?
                        <NavLink key={index} to={item.link}>
                            <img src={item.image} alt="" key={index}/>
                        </NavLink>
                        : <img  key={index} src={item.image} alt="" key={index}/>
                    }
                    </React.Fragment>
                ))
            }
        </div>
    </div>
);

export default GallerySection;